import { render, staticRenderFns } from "./CPBrokerDetails.vue?vue&type=template&id=f08367f2&scoped=true&"
import script from "./CPBrokerDetails.vue?vue&type=script&lang=js&"
export * from "./CPBrokerDetails.vue?vue&type=script&lang=js&"
import style0 from "./CPBrokerDetails.vue?vue&type=style&index=0&id=f08367f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f08367f2",
  null
  
)

export default component.exports